module.exports = __webpack_public_path__ + "assets/img/eea71351a35e6290fa67544eca4da20e.svg";